/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReturnToFacilityRequest
 */
export interface ReturnToFacilityRequest {
    /**
     * 
     * @type {string}
     * @memberof ReturnToFacilityRequest
     */
    move_in_date: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnToFacilityRequest
     */
    scheduled_move_out_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnToFacilityRequest
     */
    bed_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnToFacilityRequest
     */
    stay_type: ReturnToFacilityRequestStayTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReturnToFacilityRequest
     */
    comment?: string;
}


/**
 * @export
 */
export const ReturnToFacilityRequestStayTypeEnum = {
    LongTerm: 'Long-Term',
    ShortTerm: 'Short-Term'
} as const;
export type ReturnToFacilityRequestStayTypeEnum = typeof ReturnToFacilityRequestStayTypeEnum[keyof typeof ReturnToFacilityRequestStayTypeEnum];


/**
 * Check if a given object implements the ReturnToFacilityRequest interface.
 */
export function instanceOfReturnToFacilityRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "move_in_date" in value;
    isInstance = isInstance && "stay_type" in value;

    return isInstance;
}

export function ReturnToFacilityRequestFromJSON(json: any): ReturnToFacilityRequest {
    return ReturnToFacilityRequestFromJSONTyped(json, false);
}

export function ReturnToFacilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnToFacilityRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'move_in_date': json['move_in_date'],
        'scheduled_move_out_date': !exists(json, 'scheduled_move_out_date') ? undefined : json['scheduled_move_out_date'],
        'bed_id': !exists(json, 'bed_id') ? undefined : json['bed_id'],
        'stay_type': json['stay_type'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function ReturnToFacilityRequestToJSON(value?: ReturnToFacilityRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'move_in_date': value.move_in_date,
        'scheduled_move_out_date': value.scheduled_move_out_date,
        'bed_id': value.bed_id,
        'stay_type': value.stay_type,
        'comment': value.comment,
    };
}

